import { useQuery } from "@tanstack/react-query";
import {
  getZincApiLogs,
  getZincApiLogSummary,
} from "../services/zincApiLogService";
import { ZincApiLogFilter } from "../types/zincApiLog";

export const zincLogKeys = {
  all: ["zinc-logs"] as const,
  logs: (filter: ZincApiLogFilter) =>
    [...zincLogKeys.all, "list", filter] as const,
  summary: (filter: ZincApiLogFilter) =>
    [...zincLogKeys.all, "summary", filter] as const,
};

export const useZincApiLogs = (filter: ZincApiLogFilter) => {
  return useQuery({
    queryKey: zincLogKeys.logs(filter),
    queryFn: () => getZincApiLogs(filter),
    staleTime: 2 * 60 * 1000,
  });
};

export const useZincApiLogSummary = (filter: ZincApiLogFilter) => {
  return useQuery({
    queryKey: zincLogKeys.summary(filter),
    queryFn: () => getZincApiLogSummary(filter),
    staleTime: 2 * 60 * 1000,
  });
};
